<template>
  <div class="lib__form__main">
    <div class="lib__form__main__content">
      <p class="lib__btn--full"><i
          class="lib__icon__check__circle--success lib__icon__check__circle--big fa fa-check-circle"></i></p>
      <p class="lib__h2 lib__text-center">{{ $t('new-connection-cmh.confirmation-step.yourConnectionRequestHasBeenSent')
        }}</p>
      <p class="lib__text-center" v-html="$t('new-connection-cmh.confirmation-step.emailSent', [emailAddress])"></p>
      <p class="lib__text-center">{{ $t('new-connection-cmh.confirmation-step.oresWillContactYou') }}</p>
      <div v-if="!isProximusAvailable || !isOrangeAvailable || !isSwdeAvailable" class="lib__text-center">
        <p> {{ $t('new-connection-cmh.confirmation-step.youCanIntroduceYourConnectionRequestFor') }}</p>
        <p>
          <a v-if="!isSwdeAvailable" :href="$t('new-connection-cmh.links.waterProvider')"
            class="lib__text-weight-400 lib__link__mobile--underline">{{
              $t('new-connection-cmh.confirmation-step.waterProviderLinkText') }}</a>
        </p>
        <p>
          <a v-if="!isProximusAvailable" :href="$t('new-connection-cmh.links.proximus')"
            class="lib__text-weight-400 lib__link__mobile--underline">{{
              $t('new-connection-cmh.confirmation-step.proximusLink') }}</a>
        </p>
        <p>
          <a v-if="!isOrangeAvailable" :href="$t('new-connection-cmh.links.voo')"
            class="lib__text-weight-400 lib__link__mobile--underline">{{
              $t('new-connection-cmh.confirmation-step.vooLink') }}</a>
        </p>
      </div>
    </div>
    <hr>
    <p class="lib__h2 lib__text-info lib__text-center lib__text-weight-600"> {{
      $t('new-connection-cmh.confirmation-step.doesThisInterestYou') }}</p>
    <div class="lib__display__mobile__only lib__panel service-plus-container">
      <img :src="require('@ores/css-library/assets/img/icons/service-plus.svg')" alt="Service plus"
        class="lib__custom-box__logo lib__no-margin-top" />
      <div class="lib__custom-box">
        <h3>{{ $t('servicePlusSelection.title') }}</h3>
        <p v-html="$t('servicePlusSelection.servicePlus.why1')"></p>
        <p v-html="$t('servicePlusSelection.servicePlus.why2')"></p>
        <p v-html="$t('servicePlusSelection.servicePlus.why3')"></p>
      </div>
      <a class="lib__text-weight-600 lib__btn lib__btn--rounded lib__btn--full lib__btn--dark lib__btn--outline"
        href="https://www.ores.be/particuliers-et-professionnels/all-in">{{
          $t('new-connection-cmh.confirmation-step.iWantToKnowMore') }}</a>
      <p class="lib__text-center lib__text-info lib__text-small"> {{
        $t('new-connection-cmh.confirmation-step.weWillSendYouMoreDetailsOnPrices') }} </p>
    </div>
    <div class="lib__display__desktop__only">
      <div class="row lib__form__main__content">
        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6">
          <article class="lib__custom-box">
            <img :src="require('@ores/css-library/assets/img/icons/service-plus.svg')" alt="Service plus"
              class="lib__custom-box__logo lib__icon__service-plus" />
            <h3 v-html="$t('servicePlusSelection.servicePlus.title')"></h3>
            <p v-html="$t('servicePlusSelection.servicePlus.description')"></p>
          </article>
        </div>
        <div class="col-xs-12 col-md-6 col-sm-6 col-lg-6">
          <div class="lib__custom-box lib__custom-box--highlight">
            <h3 class="lib__text-uppercase">{{ $t('servicePlusSelection.servicePlus.why') }}</h3>
            <ul class="lib__list lib__list--plus lib__list--color-symbol-white">
              <li v-html="$t('servicePlusSelection.servicePlus.why1')"></li>
              <li v-html="$t('servicePlusSelection.servicePlus.why2')"></li>
              <li v-html="$t('servicePlusSelection.servicePlus.why3')"></li>
            </ul>
          </div>
        </div>
        <a class="lib__text-weight-600 lib__btn lib__btn--rounded lib__btn--full lib__btn--dark lib__btn--outline"
          href="https://www.ores.be/particuliers-et-professionnels/all-in">{{
            $t('new-connection-cmh.confirmation-step.iWantToKnowMore') }}</a>
        <p class="lib__btn--full lib__text-info"> {{
          $t('new-connection-cmh.confirmation-step.weWillSendYouMoreDetailsOnPrices') }} </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { State, Getter } from 'vuex-class'
import { ContactInfo } from '@/models'
import { pixelFacebookService } from '@ores/vue-library';

@Component({
  name: 'cmh-confirmation-step'
})
export default class CmhConfirmationStep extends Vue {
  @State('contactInfo', { namespace: 'newConnectionCmh/cmhContactInfo' })
  public contactInfo!: ContactInfo
  @State('emailAddress', { namespace: 'newConnectionCmh/mailRegistration' })
  public emailAddress!: string

  @Getter('isProximusAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  public isProximusAvailable!: boolean
  @Getter('isOrangeAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  public isOrangeAvailable!: boolean
  @Getter('isSwdeAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  public isSwdeAvailable!: boolean

  //#region [Method]
  public mounted() {
    pixelFacebookService.trackViewContent(
      {
        content_ids: ['CmhForm'],
        content_name: 'Confirmation Step',
        content_type: 'product'
      })
    pixelFacebookService.trackSubmitApplication()
  }

  //#endregion
}
</script>

<style scoped>
.service-plus-container {
  padding: 20px;
}
</style>
